import {useMutation} from "@tanstack/react-query";
import {UpdateUserGuideRequest} from "@/Stub/V1";
import {processValidationErrors} from "@/Util/Api/processValidationErrors";
import {MiscApiClient} from "@/Service/Api/V1/ApiClients/MiscApiClient";

export const useUpdateUserGuide = () => useMutation({
    mutationFn: async (data: UpdateUserGuideRequest) => {
        try {
            return await MiscApiClient.updateUserGuide(data);
        } catch (error) {
            await processValidationErrors(error);
            throw error;
        }
    }
});
